export default __webpack_public_path__ + "static/media/buddy1.f9fe2aad.jpeg";